var kotemplates = require('../../template/kotemplates');

module.exports = {
  shopList: {
    url: "#/shopList",
    initRoute: kotemplates.registerShopList,
    page: require("../../component/shopList/shopListIndex.html"),
  },
  idShield: {
    url: "#/idShield",
    initRoute: kotemplates.registerIdShield,
    page: require("../../component/idShield/idShield.html"),
  },
  userTask: {
    url: "#/userTask",
    initRoute: kotemplates.registerUserTask,
    page: require("../../component/userTask/userTaskIndex.html"),
  },
  entitlement: {
    url: "#/entitlement",
    initRoute: kotemplates.registerEntitlement,
    page: require("../../component/entitlement/EntitlementIndex.html"),
  },
  notice: {
    url: "#/notice",
    initRoute: kotemplates.registerNotice,
    page: require("../../component/systemNotice/noticeIndex.html"),
  },
  track: {
    url: "#/track",
    initRoute: kotemplates.registerTrack,
    page: require("../../component/track/trackIndex.html"),
  },
  workflow: {
    url: "#/workflow/:type",
    initRoute: function(){
      kotemplates.registerWorkHeader();
      kotemplates.registerWorkflow();
    },
    page: require("../../component/workflow/workflowIndex.html"),
  },
  accountApply: {
    url: "#/accountApply",
    initRoute: function(){
      kotemplates.registerWorkHeader();
      kotemplates.registerAccountApply();
    },
    page: require("../../component/workflow/accountApplyIndex.html"),
  },
  application: {
    url: "#/application/:id/:label",
    initRoute: function(){
      kotemplates.registerWorkHeader();
      kotemplates.registerWorkflow();
    },
    page: require("../../component/workflow/applicationIndex.html"),
  },
}


//////////////////
// WEBPACK FOOTER
// ./src/routes/config/pages.js
// module id = 208
// module chunks = 0